export const BUSINESS = {
  name: "Traffic Tickets Protection INC",
  phone: "(587) 700-5881",
  phoneRaw: "+15877005881",
  address: "Unit 3242, 4305 104 Ave NE",
  city: "Calgary, AB T3J 1W3",
  hours: "Open Daily 8:00 AM – 10:00 PM",
  yearsInBusiness: 11,
  rating: 4.9,
  serviceArea: "Calgary, Edmonton, Red Deer, Lethbridge, Medicine Hat & Western Canada",
  mapsQuery: "Unit 3242, 4305 104 Ave NE, Calgary, AB T3J 1W3",
};

export const SERVICES = [
  { slug: "speeding-tickets", name: "Speeding Tickets", description: "Fight speeding tickets to protect your license and insurance.", icon: "Gauge" },
  { slug: "careless-driving", name: "Careless Driving", description: "Serious charge with major insurance impact. We can help.", icon: "AlertTriangle" },
  { slug: "red-light", name: "Red Light Tickets", description: "Defend against red light and intersection tickets.", icon: "TrafficCone" },
  { slug: "stop-sign", name: "Stop Sign Tickets", description: "Rolling stops and stop sign violation defense.", icon: "Octagon" },
  { slug: "stunting", name: "Stunting Tickets", description: "Serious charge — license suspension risk. Act fast.", icon: "Flame" },
  { slug: "u-turn", name: "U-Turn Tickets", description: "Improper U-turn ticket defense.", icon: "RotateCcw" },
  { slug: "no-insurance", name: "No Insurance Tickets", description: "Heavy fines and license impact. We work to reduce penalties.", icon: "ShieldX" },
  { slug: "no-registration", name: "No Registration", description: "Defense for expired or missing vehicle registration.", icon: "FileX" },
  { slug: "tint-tickets", name: "Tint Tickets", description: "Window tint violation defense.", icon: "Sun" },
  { slug: "court-summons", name: "Mandatory Court Summons", description: "Required to appear in court? We can represent you.", icon: "Gavel" },
  { slug: "court-representation", name: "Court Representation", description: "Professional representation in traffic court.", icon: "Scale" },
  { slug: "dui", name: "DUI", description: "Driving under influence defense and consultation.", icon: "Wine" },
];

export const SERVICE_DETAIL = {
  "speeding-tickets": {
    what: "A speeding ticket is given when you drive faster than the posted speed limit. Fines depend on how much over the limit you were going.",
    consequences: "Fines from $78 to over $700, demerit points on your license, higher insurance rates for 3+ years.",
    help: "We review your ticket carefully, often find errors or reasons to reduce the fine and demerit points, and represent you in court if needed.",
  },
  "careless-driving": {
    what: "Careless driving is a serious charge. It means driving without due care for others on the road.",
    consequences: "Fine of $567+, 6 demerit points, big insurance increases (often doubling your rates).",
    help: "This is a charge worth fighting. We work to reduce it to a lesser offence so your insurance and record are protected.",
  },
  "red-light": {
    what: "A red light ticket is given when you enter an intersection after the light has turned red.",
    consequences: "Fines around $405 and demerit points on your license.",
    help: "We check the ticket, the timing, and the evidence. Many red light tickets can be reduced or dismissed.",
  },
  "stop-sign": {
    what: "A stop sign ticket is issued when you fail to come to a complete stop at a stop sign.",
    consequences: "Fines around $233 and 3 demerit points.",
    help: "We review the officer's notes and circumstances. Many of these tickets can be reduced.",
  },
  "stunting": {
    what: "Stunting is a very serious charge that includes excessive speeding (50+ km/h over) or street racing.",
    consequences: "Fines from $567 to over $2,000, immediate roadside license suspension, vehicle seizure, court appearance required.",
    help: "This charge must be fought. We work to reduce it to a less serious offence and protect your driving privileges.",
  },
  "u-turn": {
    what: "Improper or illegal U-turn ticket — making a U-turn where it's not allowed.",
    consequences: "Fine around $155 and 2 demerit points.",
    help: "We review the location and circumstances and work to reduce the charge.",
  },
  "no-insurance": {
    what: "Driving without valid insurance is a serious offence in Alberta.",
    consequences: "Fines from $2,875 to over $10,000 on a first offence, possible license suspension.",
    help: "We work to reduce penalties and present your situation properly in court.",
  },
  "no-registration": {
    what: "Driving a vehicle with expired or missing registration.",
    consequences: "Fine of $310 plus possible vehicle impound.",
    help: "Often these tickets can be reduced once registration is renewed. We handle the court process for you.",
  },
  "tint-tickets": {
    what: "Window tint that is too dark on the front side windows or windshield is illegal in Alberta.",
    consequences: "Fines around $155 plus required removal of the tint.",
    help: "We review the ticket details and the equipment used to measure the tint.",
  },
  "court-summons": {
    what: "A mandatory court summons means you must appear in court — you cannot just pay the fine.",
    consequences: "Failing to appear can lead to a warrant for your arrest and additional charges.",
    help: "We can appear in court on your behalf in most cases, so you don't have to take time off work.",
  },
  "court-representation": {
    what: "Professional representation in Alberta traffic court for any traffic-related charge.",
    consequences: "Going to court without representation often leads to higher fines and more demerit points.",
    help: "Our team handles the entire court process for you, from filing to final outcome.",
  },
  "dui": {
    what: "Driving Under the Influence — driving while impaired by alcohol or drugs.",
    consequences: "Heavy fines, immediate license suspension, criminal record, mandatory programs, possible jail time.",
    help: "DUI cases are complex. We provide consultation and help you understand your options.",
  },
};

export const REVIEWS = [
  { name: "James W.", text: "They saved all my points and got me time to pay my fine. Very thankful!", theme: "Saved my points" },
  { name: "Maria S.", text: "Very professional and explained everything clearly. I never felt rushed.", theme: "Professional service" },
  { name: "Robert T.", text: "My ticket was reduced and the process was completely stress-free.", theme: "Stress-free process" },
  { name: "Linda K.", text: "Fast responses and excellent communication. Highly recommend.", theme: "Fast responses" },
  { name: "David M.", text: "They protected my license and saved me thousands in insurance hikes.", theme: "Saved my license" },
  { name: "Susan H.", text: "Reduced my careless driving charge. I am so relieved.", theme: "Reduced my ticket" },
];

export const FAQS = [
  { q: "Can you reduce my ticket?", a: "Most traffic tickets we handle get reduced. Every case is different — we will review your ticket and explain what we can do." },
  { q: "Can you remove demerit points?", a: "In many cases yes, by reducing the charge to one with fewer or no demerit points." },
  { q: "Do I need to go to court?", a: "In most cases, no. We can appear in court on your behalf so you don't have to miss work." },
  { q: "How much do you charge?", a: "Pricing depends on the type of ticket. After we review your ticket, we will give you a clear, upfront quote." },
  { q: "How fast will you contact me?", a: "We respond to most submissions within a few hours during our open hours (8 AM – 10 PM daily)." },
  { q: "Can I upload a picture of my ticket?", a: "Yes. Just take a clear photo with your phone and upload it on our Submit Ticket page." },
  { q: "Is the AI analysis legal advice?", a: "No. The AI review is only an initial summary and does not provide legal advice. Final recommendations will come from our team." },
  { q: "Do you serve clients outside Calgary?", a: "Yes — we serve Calgary, Edmonton, Red Deer, Lethbridge, Medicine Hat, and most of Western Canada." },
];

export const WHY_US = [
  "Fast responses",
  "Honest advice",
  "Professional representation",
  "Clear communication",
  "Affordable pricing",
  "Remote court assistance",
  "Save demerit points",
  "Protect your driver's license",
  "Stress-free process",
];

export const HOW_IT_WORKS = [
  { step: 1, title: "Book your free consultation", text: "Fill out a quick form with your name, phone, email, ticket location, and a photo of your ticket. It takes less than 2 minutes." },
  { step: 2, title: "Our team reviews your case", text: "An experienced team member personally reviews your ticket, the circumstances, and your driving record to find the best path forward." },
  { step: 3, title: "Receive a quote and your options", text: "We contact you with a clear, plain-English explanation of your options and an upfront, honest price — no surprises." },
  {
    step: 4,
    title: "We represent you in court",
    text:
      "Once you say yes, our team takes over completely. We file the required paperwork with the court, request the prosecutor's disclosure, and review every detail of your ticket and the officer's notes for errors or weaknesses. We then negotiate directly with the Crown prosecutor on your behalf to work toward reducing the charge to a lesser offence, lowering the fine, and protecting your demerit points and insurance rates. On your court date, an agent appears in court for you in most cases — so you don't have to take time off work, drive downtown, or face the courtroom yourself. We follow the case all the way through to the final outcome and then send you the result in plain English.",
  },
];
